import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { Grid, Tabs } from '@material-ui/core';
import { ChangeEvent, ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../../../theme';
import DummyContent from '../../component/primitive/DummyContent';
import Tab from '../../component/primitive/Tab';
import { SPACING_LARGE, SPACING_UNIT } from '../../constant/spacing';

export type TabName = 'proposal' | 'deliverables' | 'brief' | 'reporting';

interface Props {
  value: TabName;
  onChange: (e: ChangeEvent<HTMLElement>, value: TabName) => void;
  displayProposal: boolean;
  loading: boolean;
  className?: string;
}

const ProjectPageTabs = ({
  value,
  onChange,
  displayProposal,
  loading,
  className,
}: ClassAttributes<HTMLElement> & Props) => {
  return loading ? (
    <Grid container justify="flex-start">
      <Grid item xs={12}>
        <DummyTab />
      </Grid>
    </Grid>
  ) : (
    <Tabs
      indicatorColor="primary"
      value={value}
      onChange={onChange as any}
      variant={'scrollable'}
      scrollButtons="off"
      className={className}
    >
      {displayProposal ? (
        <Tab label={<FormattedMessage id="show_project_page.tabs.proposal" />} value="proposal" />
      ) : null}

      <Tab label={<FormattedMessage id="show_project_page.tabs.deliverables" />} value="deliverables" />

      <Tab label={<FormattedMessage id="show_project_page.header.brief" />} value="brief" />

      <Tab label={<FormattedMessage id="show_project_page.tabs.reporting" />} value="reporting" />
    </Tabs>
  );
};

const animation = keyframes({
  '0%': { backgroundColor: theme.palette.grey['300'] },
  '50%': { backgroundColor: theme.palette.grey['200'] },
  '100%': { backgroundColor: theme.palette.grey['300'] },
});

const DummyTab = styled(DummyContent)({
  marginBottom: SPACING_LARGE,
  marginRight: SPACING_UNIT / 2,
  borderRadius: 2,
  animationDuration: '1500ms',
  animationFillMode: 'forwards',
  animationIterationCount: 'infinite',
  animationName: animation,
  animationTimingFunction: 'linear',
});

export default ProjectPageTabs;
